import BaseModel from './BaseModel';

class EquipmentOrder extends BaseModel {}

export default EquipmentOrder;
